import React from 'react';
import { Icon } from 'antd';

export default {
    "fields": [
        [
            {
                title: 'Assunto',
                key: 'subject',
                type: 'text',
                colSize: 24,
                beforeSave: async (Form, ParseObject, node) => {
                    await ParseObject.set('type', 'machine-and-equipament')
                    return true;
                }
            },
        ],
        [
            {
                key: 'files',
                type: 'files'
            }
        ],
    ],
    "submit": {
        "collection": "IndustrialMaintenenceDocs"
    },
    "schema": [
        {
            "title": "Assunto",
            "key": "subject",
            "dataIndex": "subject",
            "type": "text"
        },
    ],
    "title-module": "Máquinas e equipamentos",
    "title-navigation": <div><Icon type="tool" /> Máquinas e equipamentos</div>,
    "module": "IndustrialMaintenenceDocs",
    "router-base": "/panel/maquinas-e-equipamentos",
    'filterList': () => {
        return {
            'field': 'type',
            'value': 'machine-and-equipament',
        }
    }
}

